import { useLocation, useNavigate } from 'react-router-dom';
import { bins, estimateTotal, messages, type Estimate } from '@fruitways/shared';
import { ListRow, StatusLabel } from '@/components';

export function statusLabel(status: Estimate['status']) {
  if (status === 'edited')
    return <StatusLabel status="updated">{messages.status.edited}</StatusLabel>;
  if (status === 'queued')
    return <StatusLabel status="queued">{messages.status.queued}</StatusLabel>;
  return <StatusLabel status="submitted">{messages.status.submitted}</StatusLabel>;
}

/** One estimate as a navigating row: week, optional variety codes, total bins, status. */
export function EstimateRow({
  estimate,
  showVarieties,
}: {
  estimate: Estimate;
  showVarieties: boolean;
}) {
  const nav = useNavigate();
  const from = useLocation().pathname;
  return (
    <ListRow
      title={messages.common.weekN(estimate.weekNumber)}
      secondary={showVarieties ? estimate.lines.map((l) => l.varietyCode).join(', ') : undefined}
      meta={bins(estimateTotal(estimate))}
      status={statusLabel(estimate.status)}
      navigates
      onClick={() => nav(`/estimates/${estimate.id}`, { state: { from } })}
    />
  );
}
